module.exports = __webpack_public_path__ + "static/media/report.8e963947.pdf";